"use client";

import { useState, useCallback } from "react";
import { debounce } from "lodash";
import { useUserFilterActions } from "../../ducks/filter/hooks/actions";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

export function QuerySearch() {
  const { updateFilter } = useUserFilterActions();
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsLoading(true);
      updateFilter({ key: "search", value: event.target.value });
      setTimeout(() => setIsLoading(false), 500);
    },
    [updateFilter]
  );

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    [handleInputChange]
  );

  return (
    <div className="relative">
      <Input
        placeholder="Pesquisar Query"
        className="my-2 pr-10"
        onChange={debouncedHandleInputChange}
      />
      {isLoading && (
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <Loader2 className="h-4 w-4 animate-spin text-gray-400" />
        </div>
      )}
    </div>
  );
}
